module.exports = __webpack_public_path__ + "img/arrow1.45c4e9f9.svg";